import type { ColumnTypes } from "custom-viz";

import {
  hasLatitudeAndLongitudeColumns,
  isAddress,
  isAny,
  isAvatarURL,
  isBoolean,
  isCategory,
  isCoordinate,
  isCountry,
  isCurrency,
  isDate,
  isDateWithoutTime,
  isEmail,
  isEntityName,
  isFK,
  isFloat,
  isID,
  isImageURL,
  isInteger,
  isLatitude,
  isLongitude,
  isNumber,
  isNumeric,
  isNumericBaseType,
  isPK,
  isPercentage,
  isProduct,
  isQuantity,
  isScore,
  isSource,
  isState,
  isString,
  isStringLike,
  isSummable,
  isTime,
  isTitle,
  isURL,
} from "./isa";

export const customVizColumnTypes: ColumnTypes = {
  hasLatitudeAndLongitudeColumns,
  isAddress,
  isAny,
  isAvatarURL,
  isBoolean,
  isCategory,
  isCoordinate,
  isCountry,
  isCurrency,
  isDate,
  isDateWithoutTime,
  isEmail,
  isEntityName,
  isFK,
  isFloat,
  isID,
  isImageURL,
  isInteger,
  isLatitude,
  isLongitude,
  isNumber,
  isNumeric,
  isNumericBaseType,
  isPK,
  isPercentage,
  isProduct,
  isQuantity,
  isScore,
  isSource,
  isState,
  isString,
  isStringLike,
  isSummable,
  isTime,
  isTitle,
  isURL,
};
